const x = {
  content: `Der Datensatz umfasst die circa 100 von der Stadt Wuppertal in den Innenstadtbereichen von 
  Elberfeld und Barmen zur Bewirtschaftung der öffentlichen Parkplatzflächen und Parkstreifen 
  betriebenen Parkscheinautomaten (PSA). In allen anderen Stadtteilen werden keine Parkgebühren 
  mittels PSA durch die Stadt Wuppertal erhoben. Die Standorte der PSA wurden auf der 
  Grundlage kommunaler Orthofotos mit einer Genauigkeit von ca. 1 m digitalisiert. Darüber 
  hinaus enthält der Datensatz zu jedem Objekt Informationen zur Bezeichnung des PSA, 
  zur Anzahl der zugehörigen Stellplätze und zu den Parkgebühren. Der Datenbestand der PSA 
  unterliegt seltenen Änderungen, die im Primärdatenbestand mit einem Fachverfahren 
  innerhalb des webbasierten städtischen Geoinfomationssystems "WuNDa" zeitnah erfasst werden. 
  
  
  <img width="300" alt="Bildschirmfoto 2020-11-05 um 11 22 32" src="https://user-images.githubusercontent.com/837211/98228706-3c59ca80-1f59-11eb-9a10-fa47558d853d.png">
  
  Die als Open Data unter der Lizenz CC BY 4.0 bereitgestellten ESRI - Shapefiles und KML - Dateien 
  werden in einem automatisierten Prozess wöchentlich aktualisiert.`,
};
export default x;
